/**
 * The line of text the voice widget shows, built from the Realtime events
 * (#1824): what the person just said, then the answer as it streams in.
 */

export interface VoiceLine {
  text: string
  /** The answer has started, so a late transcript of the question must not replace it. */
  answering: boolean
}

export const NO_VOICE_LINE: VoiceLine = { text: '', answering: false }

interface VoiceLineEvent {
  type: string
  delta?: string
  transcript?: string
}

export function nextVoiceLine(line: VoiceLine, event: VoiceLineEvent): VoiceLine {
  switch (event.type) {
    case 'input_audio_buffer.speech_started':
      return NO_VOICE_LINE
    case 'conversation.item.input_audio_transcription.delta':
      return line.answering || !event.delta ? line : { ...line, text: line.text + event.delta }
    case 'conversation.item.input_audio_transcription.completed':
      return line.answering || !event.transcript ? line : { ...line, text: event.transcript }
    // Azure GA names first, the OpenAI beta names after them
    case 'response.output_audio_transcript.delta':
    case 'response.audio_transcript.delta':
    case 'response.output_text.delta':
    case 'response.text.delta':
      if (!event.delta) return line
      return { text: (line.answering ? line.text : '') + event.delta, answering: true }
    case 'response.output_audio_transcript.done':
    case 'response.audio_transcript.done':
      return event.transcript ? { text: event.transcript, answering: true } : line
    case 'response.created':
      // Tool calls answer several times per turn; each answer starts afresh.
      return line.answering ? { ...line, answering: false } : line
    default:
      return line
  }
}
